import { render, staticRenderFns } from "./IntentionMessageDialog.vue?vue&type=template&id=712c2973&scoped=true"
import script from "./IntentionMessageDialog.vue?vue&type=script&lang=ts"
export * from "./IntentionMessageDialog.vue?vue&type=script&lang=ts"
import style0 from "./IntentionMessageDialog.vue?vue&type=style&index=0&id=712c2973&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "712c2973",
  null
  
)

export default component.exports